import ButtonSet from '@jetbrains/ring-ui/components/button-set/button-set'
import moment from 'moment'
import React from 'react'

import {useDisplayErrorAlert} from '../HttpsConfigurationPage.hooks'
import type {Certificate} from '../HttpsConfigurationPage.types'

import CertificateRenewal from './CertificateRenewal/CertificateRenewal'
import ConnectorSettings from './ConnectorSettings/ConnectorSettings'
import RemoveCertificateButton from './RemoveCertificateButton/RemoveCertificateButton'
import UploadCertificateButton from './UploadCertificateButton/UploadCertificateButton'

import styles from './CertificateInfo.css'

import {useAppSelector} from 'src/hooks/react-redux'

const dateFormat = 'D MMM YYYY, HH:mm'

type Props = Certificate

function CertificateInfo({
  subject,
  issuer,
  notBefore,
  notAfter,
  fetchedFromAcme,
  connector,
}: Props) {
  const notBeforeDate = React.useMemo(() => moment.utc(notBefore), [notBefore])
  const notAfterDate = React.useMemo(() => moment.utc(notAfter), [notAfter])
  const daysBeforeExpiration = React.useMemo(
    () => Math.ceil(moment.duration(notAfterDate.diff(moment.utc())).asDays()),
    [notAfterDate],
  )

  const error = useAppSelector(state => state.https.error)
  useDisplayErrorAlert(error)

  return (
    <>
      <div className={styles.info}>
        <div>{'Subject'}</div>
        <div>{subject}</div>
        <div>{'Issuer'}</div>
        <div>{issuer}</div>
        <div>{'Validity Period'}</div>
        <div>{`${notBeforeDate.format(dateFormat)} GMT - ${notAfterDate.format(
          dateFormat,
        )} GMT`}</div>
      </div>
      <ButtonSet>
        <UploadCertificateButton />
        <RemoveCertificateButton />
      </ButtonSet>
      {fetchedFromAcme && (
        <div className={styles.caption}>
          {"The certificate is fetched from Let's Encrypt. It will be revoked on removal."}
        </div>
      )}
      <CertificateRenewal
        daysBeforeExpiration={daysBeforeExpiration}
        fetchedFromAcme={fetchedFromAcme}
      />
      <ConnectorSettings {...connector} />
    </>
  )
}

export default CertificateInfo
